import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Manifesto } from "@/components/Manifesto";
import { Gallery } from "@/components/Gallery";
import { Films } from "@/components/Films";
import { Marquee } from "@/components/Marquee";
import { Registration } from "@/components/Registration";
import { Pricing } from "@/components/Pricing";
import { Testimonials } from "@/components/Testimonials";
import { BookingForm } from "@/components/BookingForm";
import { InstagramStrip } from "@/components/InstagramStrip";
import { Footer } from "@/components/Footer";
import { WhatsAppFab } from "@/components/WhatsAppFab";

export default function Home() {
  return (
    <main className="bg-[#0A0A0A] text-[#F5F4F0]">
      <Nav />
      <Hero />
      <Registration />
      <Manifesto />
      <Marquee />
      <Gallery />
      <Films />
      <Pricing />
      <Testimonials />
      <BookingForm />
      <InstagramStrip />
      <Footer />
      <WhatsAppFab />
    </main>
  );
}
